/* eslint-disable import/prefer-default-export */
import NotifyRequests from '../../server/notify';
import { addLoading, removeLoading } from './loading';

export const getListNotify = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await NotifyRequests.getListNotify(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getNotificationHistoryList = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await NotifyRequests.getNotificationHistoryList(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const createNotify = newNotify => async (dispatch) => {
  dispatch(addLoading());
  try {
    await NotifyRequests.createNotify(newNotify);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateNotify = notify => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await NotifyRequests.updateNotify(notify);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateNotifyDisable = notify => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await NotifyRequests.updateNotifyDisable(notify);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteNotify = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await NotifyRequests.deleteNotify(id);
  } finally {
    dispatch(removeLoading());
  }
};
